import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource} from "kea-resource";

const controller = rpcController("SeguimientoVentas");

/**Resource del reporte de estadísticas de clientes*/
export const RepSeguimientoVentas = cacheResource({
    Generar: async (
        parametros:  models.ParamsSeguimientoVentas): Promise<string> =>
        await controller("GenerarReporteSeguimientoVentas", {}, parametros)
}, {
    }, {
})


// WEBPACK FOOTER //
// ./app/resources/items/seguimientoventas.tsx